import React, { useMemo, useState } from 'react';
import DraftTable from '../DraftTable';
import { Button, Stack, Typography } from '@mui/material';
import { useUpdateCampaignMutation } from '../../../api/campaignSlice';

function CampaignPreview(props) {
    const [checkedIncludedPhysicians, setCheckedIncludedPhysicians] = useState([]);
    const [checkedExcludedPhysicians, setCheckedExcludedPhysicians] = useState([]);
    const [updateCampaign] = useUpdateCampaignMutation();

    const allPhysicians = useMemo(() => {
        const physicians = {};

        if (!props.preview) {
            return physicians;
        }

        Object.keys(props.preview.cards).forEach((physicianId) => {
            props.preview.cards[physicianId].forEach((card) => {
                if (!Object.keys(physicians).includes(physicianId)) {
                    physicians[physicianId] = card.owner;
                }
            });
        });

        return physicians;
    }, [props.preview]);

    const allIncludedPhysicians = useMemo(() => {
        var includedPhysicians = [];
        Object.keys(allPhysicians).forEach((physicianId) => {
            if (!props.campaign.settings['excluded_physicians'].includes(parseInt(physicianId))) {
                includedPhysicians.push(allPhysicians[physicianId]);
            }
        });
        return includedPhysicians;
    }, [allPhysicians, props.campaign]);

    const allExcludedPhysicians = useMemo(() => {
        var excludedPhysicians = [];
        Object.keys(allPhysicians).forEach((physicianId) => {
            if (props.campaign.settings['excluded_physicians'].includes(parseInt(physicianId))) {
                excludedPhysicians.push(allPhysicians[physicianId]);
            }
        });
        return excludedPhysicians;
    }, [allPhysicians, props.campaign]);

    const handleIncludeClick = async() => {
        await updateCampaign({
            campaignId: props.campaign.id,
            requestBody: {
                settings: {
                    ...props.campaign.settings,
                    excluded_physicians: props.campaign.settings['excluded_physicians'].filter((physicianId) => !checkedExcludedPhysicians.includes(physicianId))
                }
            }
        });
        setCheckedExcludedPhysicians([]);
    }

    const handleExcludeClick = async() => {
        await updateCampaign({
            campaignId: props.campaign.id,
            requestBody: {
                settings: {
                    ...props.campaign.settings,
                    excluded_physicians: checkedIncludedPhysicians
                }
            }
        });
        setCheckedIncludedPhysicians([]);
    }
    
    return (
        <Stack spacing={3}>
            <Stack spacing={1}>
                { props.campaign.status === 'open' &&
                    <Stack direction='row' alignItems='center' justifyContent='space-between'>
                        <Typography variant="h6">Included Physicians</Typography>
                        { checkedIncludedPhysicians.length > 0 &&
                            <Button variant='contained' size='small' onClick={handleExcludeClick}>Exclude Checked Physicians</Button>
                        }
                    </Stack>
                }
                { props.preview && 
                    <DraftTable 
                        physicians={allIncludedPhysicians} 
                        checkedPhysicians={checkedIncludedPhysicians} 
                        setCheckedPhysicians={setCheckedIncludedPhysicians}
                        drafts={props.preview?.cards} 
                        campaign={props.campaign} 
                        isLoadingDrafts={props.isLoadingDrafts} 
                    />
                }
                
            </Stack>
            { props.campaign.status === 'open' && 
                <Stack spacing={1}>
                    <Stack direction='row' alignItems='center' justifyContent='space-between'>
                        <Typography variant="h6">Excluded Physicians</Typography>
                        { checkedExcludedPhysicians.length > 0 &&
                            <Button variant='contained' size='small' onClick={handleIncludeClick}>Include Checked Physicians</Button>
                        }
                    </Stack>
                    { props.preview && 
                        <DraftTable 
                            physicians={allExcludedPhysicians}
                            checkedPhysicians={checkedExcludedPhysicians} 
                            setCheckedPhysicians={setCheckedExcludedPhysicians}
                            drafts={props.preview?.cards} 
                            campaign={props.campaign} 
                            isLoadingDrafts={props.isLoadingDrafts} 
                        />
                    }
                </Stack>
            }
        </Stack>
    )
}

export default CampaignPreview;